<template>
    <div>
        <a :href="`#video-modal-${name}`"
            :class="[
                { 'bg-video-play-before--square': square },
                { 'rounded-forced': rounded },
                { 'border-white border-4 rounded-xl': !no_border },
                'bg-video-play-before block overflow-hidden'
            ]">

            <img :src="[thumbnail != '' ? thumbnail : unlisted ? `https://i.ytimg.com/vi/${id}/mqdefault.jpg` : `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`]"
                alt="Youtube thumbnail"
                :class="[{ 'object-cover h-64': square }, 'w-full']">
        </a>

        <modal :name="`video-modal-${name}`" youtube="true">
            <youtube-embed :id="id"></youtube-embed>
        </modal>
    </div>
</template>

<script>
import Modal from './Modal.vue'
import YoutubeEmbed from './YoutubeEmbed.vue'

export default {
    props: {
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        square: {
            type: Boolean,
            required: false
        },
        rounded: {
            type: Boolean,
            required: false
        },
        no_border: {
            type: Boolean,
            required: false
        },
        unlisted: {
            type: Boolean,
            required: false
        },
        thumbnail: {
            type: String,
            default: '',
            required: false
        },
    },
    components: {
        Modal,
        YoutubeEmbed
    }
}
</script>

<style lang="scss">
    .rounded-forced {
        @apply .rounded-xl #{!important};
    }
</style>
